<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <mat-icon class="icon">warning</mat-icon>
      Information Missing
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p class="information">{{ getMessage() }}</p>
    <div class="missing-required-fields">
      @if (missingItemsRequiredFields?.length) {
        <im-display-missing-required-fields
          [title]="'Items'"
          [missingRequiredFields]="missingItemsRequiredFields"
          >
        </im-display-missing-required-fields>
      }
      @if (missingSowRequiredFields?.length) {
        <im-display-missing-required-fields
          [title]="'Scope of work'"
          [missingRequiredFields]="missingSowRequiredFields"
          >
        </im-display-missing-required-fields>
      }
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button (click)="onClick()" mat-button color="primary">UNDERSTOOD</button>
  </mat-card-actions>
</mat-card>
